import { useState } from 'react';
import { api } from '../api/client';
import { downloadText } from '../lib/download';
import { Button, Card } from '../ui';

/**
 * راهنما و فهرست کارها — the in-depth manual (with every assumption) and the living to-do, fetched from
 * /api/motor/manual. Collapsed by default; expandable and downloadable. The same content the AI answers
 * help questions from, so the tool is self-documenting.
 */
export function HelpPanel() {
  const [open, setOpen] = useState(false);
  const [manual, setManual] = useState('');
  const [todo, setTodo] = useState('');
  const [loaded, setLoaded] = useState(false);
  const [tab, setTab] = useState<'manual' | 'todo'>('manual');

  function toggle() {
    const next = !open;
    setOpen(next);
    if (next && !loaded) {
      void api<{ manual: string; todo: string }>('/api/motor/manual').then((r) => {
        if (r.ok) {
          const b = r.body as { manual: string; todo: string };
          setManual(b.manual);
          setTodo(b.todo);
          setLoaded(true);
        }
      });
    }
  }

  return (
    <Card title="راهنمای کامل و فهرست کارها">
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
        <Button variant="secondary" onClick={toggle}>
          {open ? 'بستن راهنما' : 'نمایش راهنما (با همهٔ مفروضات)'}
        </Button>
        {loaded ? (
          <>
            <Button
              variant="secondary"
              onClick={() => setTab('manual')}
              disabled={tab === 'manual'}
            >
              راهنما
            </Button>
            <Button variant="secondary" onClick={() => setTab('todo')} disabled={tab === 'todo'}>
              فهرست کارها
            </Button>
            <Button
              variant="secondary"
              onClick={() => downloadText('kia-motor-manual.md', `${manual}\n\n${todo}`)}
            >
              دریافت راهنما (Markdown)
            </Button>
          </>
        ) : null}
        <span style={{ color: 'var(--ink-3)' }}>
          می‌توانید در کادر «طراحی هوشمند» هر سؤالی دربارهٔ ابزار بپرسید؛ دستیار پاسخ می‌دهد.
        </span>
      </div>

      {open && loaded ? (
        <pre
          style={{
            marginTop: 12,
            maxHeight: 460,
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
            direction: 'rtl',
            textAlign: 'right',
            fontFamily: 'inherit',
            lineHeight: 1.8,
            background: 'var(--bg)',
            padding: 12,
            borderRadius: 8,
          }}
        >
          {tab === 'manual' ? manual : todo}
        </pre>
      ) : null}
    </Card>
  );
}
